import Requisicao from "./RequisicaoService";

class PedidoService {
    static async listar(filter, pagina) {
        return Requisicao.post('pedido', {            
            filter: filter,
            pagina: pagina
        });
    } 

    static async get(id) {
        return Requisicao.get('pedido/' + id);
    }

    static async aprovarPagamento(id) {
        return Requisicao.post('pedido/aprovar_pagamento/' + id);
    } 
    
    static async cancelarPedido(id, user) {
        return Requisicao.delete('pedido/' + id + '/' + user);
    }   
}

export default PedidoService;
